<template lang="pug">
.configuration
  .section(v-if='isMany')
    .row(v-for="prop in notArrayProperites()")
      .property {{ schema[prop].title }}
      .value {{ config[prop] }}
    .items(v-for="prop in arrayProperites()")
      .items-title {{ schema[prop].title }}:
      .item(v-for="item in config[prop]")
        .row(v-for="(value, key) in item")
          .property  {{ schema[prop].items.properties[key].title }}
          .value
            font-awesome-icon(v-if='typeof value == "boolean" && value === true', icon="square-check")
            font-awesome-icon.square-false(v-if='typeof value == "boolean" && value === false', icon="square")
            span(v-if='!(typeof value == "boolean" || "object" ) || typeof value == "string" || typeof value == "number"') {{ value }}
  .section(v-if='!isMany')
    .row(v-for="(value, key) in config")
      .property {{ schema[key].title }}
      .value
        font-awesome-icon(v-if='typeof value == "boolean" && value === true', icon="square-check")
        font-awesome-icon.square-false(v-if='typeof value == "boolean" && value === false', icon="square")
        span(v-if='!(typeof value == "boolean" || "object" ) || typeof value == "string" || typeof value == "number"') {{ value }}
</template>

<script>

export default {
  props: ['config', 'schema'],
  methods: {
    notArrayProperites () {
      const notArrayProperites = []
      for (const key of Object.keys(this.schema)) {
        if (this.schema[key].type !== 'array') notArrayProperites.push(key)
      }
      return notArrayProperites
    },
    arrayProperites () {
      const arrayProperites = []
      for (const key of Object.keys(this.schema)) {
        if (this.schema[key].type === 'array') arrayProperites.push(key)
      }
      return arrayProperites
    }
  },
  computed: {
    isMany () {
      for (const key of Object.keys(this.schema)) {
        if (this.schema[key].type === 'array') return true
      }
      return false
    }
  }
}
</script>
<style lang="scss">
@import "../../../../theme-m4b/src/common/var.scss";
.configuration {
  .items-title {
    font-weight: bold;
    margin-top: 10px;
  }
  .item {
    border-top: 1px solid $--color-warning;
    margin-top: 5px;
    padding-top: 9px;
  }
  .row {
    height: 10px;
    line-height: 10px;
    .property {
      width: 250px;
      &.float-right {
        text-align: right;
      }
    }
    .value {
      margin-left: -65px;
    }
    .square-false {
      color: $--color-white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/OnlyOwnMedia/ConfigurationTable.vue